export default __webpack_public_path__ + "static/media/psihologija.ca3515ab.gif";